// import React from 'react';
// import ReactDOM from 'react-dom/client';
// import './index.css';
// import App from './App';
// import reportWebVitals from './reportWebVitals';
// import "@radix-ui/themes/styles.css";
// import ReactGA from 'react-ga';
// import { Provider } from 'react-redux';  // Import Provider from react-redux
// import  store  from '../src/redux/store';   // Import the store

// ReactGA.initialize('G-TQY01XMZKT'); // Replace with your Google Analytics ID
// ReactGA.pageview(window.location.pathname + window.location.search);

// const link = document.createElement('link');
// link.href = 'https://fonts.googleapis.com/css2?family=Poppins:wght@300;400;500;600;700;800&display=swap';
// link.rel = 'stylesheet';
// document.head.appendChild(link);

// const root = ReactDOM.createRoot(document.getElementById('root'));
// root.render(
//   <React.StrictMode>
//     <Provider store={store}> {/* Wrap the app with Provider */}
//       <App />
//     </Provider>
//   </React.StrictMode>
// );

// // If you want to start measuring performance in your app, pass a function
// // to log results (for example: reportWebVitals(console.log))
// // or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();

import React from "react";
import ReactDOM from "react-dom/client";
import "stream-chat-react/dist/css/v2/index.css";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import "@radix-ui/themes/styles.css";
import ReactGA from "react-ga";
import { Provider } from "react-redux"; // Import Provider from react-redux
import { PersistGate } from "redux-persist/integration/react"; // Import PersistGate
import store, { persistor } from "./redux/store"; // Import store and persistor
import "react-big-calendar/lib/css/react-big-calendar.css"; // Import CSS here

ReactGA.initialize("G-TQY01XMZKT"); // Replace with your Google Analytics ID
ReactGA.pageview(window.location.pathname + window.location.search);

// Dynamically load Google Fonts
const link = document.createElement("link");
link.href =
  "https://fonts.googleapis.com/css2?family=Poppins:wght@300;400;500;600;700;800&display=swap";
link.rel = "stylesheet";
document.head.appendChild(link);

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <Provider store={store}>
      {" "}
      {/* Wrap the app with Provider */}
      <PersistGate loading={null} persistor={persistor}>
        {" "}
        {/* Add PersistGate */}
        <App />
      </PersistGate>
    </Provider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
